import template from './scoresheet_actions.html'
import './scoresheet_actions.css'

export default {
  template,
  controller: 'scoresheetActionsController as scoresheetActions'
}
